<template>
  <div>
    <v-card outlined
            class="mt-4"
            v-for="carrinho in fornecedor.carrinhos" :key="carrinho.id">
      <px-listagem-carrinho-resposta-header :remover-carrinho="removerCarrinho"
                                            :disable-actions="disableActions"
                                            :carrinho="carrinho"/>
      <v-divider/>
      <px-listagem-carrinho-produtos
        :disable-actions="disableActions"
        :carrinho="carrinho"
        :remover-produto="removerProduto"/>
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { CasaDecimalUtils } from 'px-components';
import ListagemCarrinhoProdutos from './ListagemCarrinhoProdutos.vue';
import ListagemCarrinhoRespostaHeader from './ListagemCarrinhoRespostaHeader.vue';

export default {
  name: 'ListagemCarrinhoRespostas',
  props: {
    fornecedor: {
      type: Object,
      required: true,
    },
    disableActions: {
      default: false,
    },
    removerCarrinho: {
      type: Function,
      required: true,
    },
    removerProduto: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador']),
    casaDecimal() {
      return (carrinho) => {
        const produtos = carrinho.produtos.map(
          produto => produto.respostaCotacaoProduto.cotacaoProduto.produto,
        );
        return CasaDecimalUtils.getCasaDecimal(produtos);
      };
    },
  },

  components: {
    pxListagemCarrinhoProdutos: ListagemCarrinhoProdutos,
    pxListagemCarrinhoRespostaHeader: ListagemCarrinhoRespostaHeader,
  },
};
</script>
